import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useCalculationField, useDispatch } from "@ploy-lib/calculation";
import { Button, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { AddCircleOutlineOutlined, DeleteOutline, CancelOutlined } from "@material-ui/icons";
import React, { useCallback, useState } from "react";
import { TextField } from "@ploy-ui/form-fields";
import { Formik, Field as FormikField } from "formik";
import * as Yup from "yup";
import { ErrorDisplay } from "@ploy-lib/types";
import { defineMessages, useIntl } from "react-intl";
import { LabelComponent } from "../../field";
addRegisteredSectionLayout({
    name: "ProbateSettlementSection",
    displayName: "ProbateSettlementSection",
    settings: {
        editableOptions: {}
    }
});
const messages = defineMessages({
    captionTitle: {
        defaultMessage: "Who will you release?",
        id: "template-form.field.probateSettlements.captionTitle"
    },
    addButton: {
        defaultMessage: "Add",
        id: "template-form.field.probateSettlements.addButton"
    },
    addPerson: {
        defaultMessage: "Add new person",
        id: "template-form.field.probateSettlements.addPerson"
    },
    nameLabel: {
        defaultMessage: "Name",
        id: "template-form.field.probateSettlements.nameLabel"
    },
    validationMessage: {
        defaultMessage: "Field is required",
        id: "template-form.field.probateSettlements.validationMessage"
    },
    helperText: {
        defaultMessage: "We need the identity of the recipient",
        id: "template-form.field.probateSettlements.helperText"
    }
});
const useStyles = makeStyles(theme => ({
    root: {
        flexDirection: "column"
    },
    boxes: {
        border: "1px solid #757575",
        borderRadius: "4px",
        backgroundColor: "white"
    },
    list: {},
    listItem: { marginBottom: theme.spacing(1.5) },
    button: {
        padding: theme.spacing(1) + "px " + theme.spacing(2) + "px",
        justifyContent: "start"
    },
    icon: {
        height: theme.typography.button.lineHeight,
        width: theme.typography.button.lineHeight
    },
    addNames: {
        paddingTop: theme.spacing(6) + "px !important",
        paddingBottom: theme.spacing(4) + "px !important",
        backgroundColor: theme.palette.primary.light,
        borderColor: theme.palette.secondary.light,
        borderWidth: 1,
        borderTopStyle: "solid",
        borderBottomStyle: "solid",
        rowGap: theme.spacing(2)
    }
}), { name: "ProbateSettlementSection" });
const calcRulesNamespace = "Calculator";
const calcRulesName = "PROBATE_RECIPIENTS";
const ProbateSettlementSection = (props) => {
    const styles = useStyles(props);
    const intl = useIntl();
    const [addNewPerson, setAddNewPerson] = React.useState(false);
    const dispatch = useDispatch();
    const probateField = useCalculationField(calcRulesNamespace, calcRulesName);
    var disabled = !probateField.enabled;
    const addItem = useCallback((newItem) => {
        let probateList = probateField.value;
        probateList ??= [];
        probateList.push(newItem);
        dispatch({
            type: "patch",
            payload: {
                patches: [
                    {
                        target: calcRulesName,
                        namespace: calcRulesNamespace,
                        value: probateList,
                        overwrite: true
                    }
                ]
            }
        });
    }, [dispatch, probateField]);
    const deleteItem = useCallback((indexToRemove) => {
        let probateList = probateField.value;
        probateList = probateList.filter((_, i) => i !== indexToRemove);
        dispatch({
            type: "patch",
            payload: {
                patches: [
                    {
                        target: calcRulesName,
                        namespace: calcRulesNamespace,
                        value: probateList,
                        overwrite: true
                    }
                ]
            }
        });
    }, [dispatch, probateField.value]);
    const [showHelperText, setShowHelperText] = useState(false);
    const toggleHelperText = useCallback((e) => {
        setShowHelperText(show => !show);
        e.stopPropagation();
    }, []);
    const probateSettlementValidationSchema = Yup.object({
        name: Yup.string().required(intl.formatMessage(messages.validationMessage))
    });
    return (_jsxs(Grid, { container: true, item: true, spacing: 1, className: clsx(styles.root, props.className), children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(LabelComponent, { labelText: _jsx(Typography, { variant: "caption", children: intl.formatMessage(messages.captionTitle) }), trimmedHelperText: intl.formatMessage(messages.helperText), showHelperText: showHelperText, toggleHelperText: toggleHelperText }) }), (probateField.value?.length || 0) > 0 && (_jsx(Grid, { item: true, xs: 12, children: _jsx(List, { className: clsx(styles.list), children: probateField.value?.map((name, i) => (_jsxs(ListItem, { className: clsx(styles.listItem, styles.boxes), children: [_jsx(ListItemText, { primary: name }), _jsx(ListItemSecondaryAction, { children: _jsx(IconButton, { disabled: disabled, onClick: () => {
                                        deleteItem(i);
                                    }, children: _jsx(DeleteOutline, {}) }) })] }, name + i.toString()))) }) })), addNewPerson ? (_jsx(Grid, { item: true, xs: 12, children: _jsx(Formik, { validationSchema: probateSettlementValidationSchema, onSubmit: (newEntry, _) => {
                        addItem(newEntry.name);
                    }, initialValues: { name: "" }, children: formikProps => (_jsxs(Grid, { container: true, item: true, className: clsx(styles.addNames), children: [_jsx(FormikField, { name: "name", component: TextField, errorDisplay: ErrorDisplay.Touched, fullWidth: true, label: intl.formatMessage(messages.nameLabel), style: { padding: 4 } }), _jsxs(Grid, { item: true, container: true, direction: "row", justifyContent: "space-between", children: [_jsx(Button, { variant: "contained", onClick: () => {
                                            setAddNewPerson(false);
                                            formikProps.submitForm();
                                        }, disabled: disabled ||
                                            !formikProps.isValid ||
                                            formikProps.values.name.length === 0, children: intl.formatMessage(messages.addButton) }), _jsx(IconButton, { children: _jsx(CancelOutlined, { className: styles.icon, onClick: () => setAddNewPerson(false) }) })] })] })) }) })) : (_jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { fullWidth: true, variant: "outlined", startIcon: _jsx(AddCircleOutlineOutlined, { className: styles.icon }), className: clsx(styles.button, styles.boxes), onClick: () => {
                        setAddNewPerson(true);
                    }, disabled: disabled, children: intl.formatMessage(messages.addPerson) }) }))] }));
};
ProbateSettlementSection.displayName = "ProbateSettlementSection";
export { ProbateSettlementSection };
//# sourceMappingURL=ProbateSettlementSection.js.map